<template>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-md-2">
                    <div class="logo">
                        <router-link :to="{ name: 'home' }">
                            <div class="img_box">
                                <img :src="require('@/assets/images/icon/logo.svg')" />
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="other_link">
                        <router-link :to="'/SSOHolaEc'">HOLA 和樂家居官網</router-link>
                        <router-link v-for="(routes, index) in footerList" v-bind:key="index" :to="routes.to">
                            {{ routes.text }}
                        </router-link>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <p v-for="(standard, index) in footerText" v-bind:key="index">{{ standard.text }}</p>
                        <p>如您欲取消訂閱行銷訊息，請 <a href="https://www.hola.com.tw/my-account/onlineContactform">聯絡客服</a> 為您確認身分後再行取消</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                footerList: [{
                        text: '常見問答',
                        to: {
                            name: 'faq'
                        },
                    },
                    {
                        text: '服務條款',
                        to: {
                            name: 'policy'
                        },
                    },
                    {
                        text: '網站地圖',
                        to: {
                            name: 'sitemap'
                        },
                    }
                ],
                footerText: [
                    {
                      text: '和樂家居股份有限公司｜臺北市內湖區新湖三路23號5樓'
                    },
                    {
                      text: '統一編號｜53096709'
                    },
                    {
                      text: '版權所有｜© Copyright 2024 HOLA Furnishing CO., LTD. All Rights Reserved'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters('home', [
                'homeCompanyUrl'
            ]),
        },
        created() {
            this.loadHomeCompanyUrl();
        },
        methods: {
            ...mapActions('home', [
                'loadHomeCompanyUrl'
            ]),
        },

    };
</script>
